import styled from 'styled-components'

export const Page = styled.div`
  padding: 10px 4px 32px;
  width: 100%;
  box-sizing: border-box;
`

export const PageHeader = styled.div`
  margin-bottom: 16px;
`

export const PricingLayout = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 300px;
  gap: 16px;
  align-items: start;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`

export const PricingMain = styled.div`
  min-width: 0;
`

export const SectionTitle = styled.h4`
  margin: 0 0 10px;
  font-size: 16px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.88);
`

export const TermToggleWrap = styled.div`
  margin: 0 0 20px;
`

export const TermToggle = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  gap: 8px;
`

export const TermOption = styled.button<{ $active?: boolean }>`
  appearance: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  transition: border-color 0.15s ease, background 0.15s ease, color 0.15s ease;
  background: ${p => (p.$active ? '#e6f4ff' : '#fff')};
  color: ${p => (p.$active ? '#1677ff' : 'rgba(0, 0, 0, 0.88)')};
  border: 1px solid ${p => (p.$active ? '#1677ff' : '#d9d9d9')};

  &:hover {
    border-color: #1677ff;
    color: #1677ff;
  }
`

export const TermRadio = styled.span<{ $active?: boolean }>`
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 1px solid ${p => (p.$active ? '#1677ff' : '#d9d9d9')};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: #fff;

  &::after {
    content: '';
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${p => (p.$active ? '#1677ff' : 'transparent')};
  }
`

export const DiscountBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 0 7px;
  border-radius: 4px;
  background: #1677ff;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
`

export const ModulesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
`

export const ModuleRow = styled.div<{ $clickable?: boolean }>`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto auto;
  gap: 12px;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;
  cursor: ${p => (p.$clickable ? 'pointer' : 'default')};

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: #fafafa;
  }

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
    gap: 8px;
  }
`

export const ModuleName = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.88);
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`

export const ModulePrice = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.88);
  white-space: nowrap;
  text-align: right;
`

export const PriceStrike = styled.span`
  color: rgba(0, 0, 0, 0.45);
  font-weight: 400;
  text-decoration: line-through;
  margin-right: 8px;
`

export const ModuleActions = styled.div`
  display: flex;
  justify-content: flex-end;
  min-width: 110px;
`

export const SummaryCard = styled.aside`
  background: #fff;
  color: rgba(0, 0, 0, 0.88);
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  padding: 16px;
  position: sticky;
  top: 16px;

  @media (max-width: 900px) {
    position: static;
  }
`

export const SummaryLine = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f0f0f0;

  &:last-child {
    margin-bottom: 0;
    padding-bottom: 0;
    border-bottom: none;
  }
`

export const SummaryLabel = styled.div`
  font-size: 13px;
  color: rgba(0, 0, 0, 0.45);
  line-height: 1.35;
`

export const SummaryValue = styled.div`
  font-size: 20px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.88);
  line-height: 1.2;
`

export const SummaryValueLg = styled(SummaryValue)`
  font-size: 24px;
  color: #1677ff;
`

export const SummaryStrike = styled.span`
  color: rgba(0, 0, 0, 0.45);
  font-size: 14px;
  font-weight: 400;
  text-decoration: line-through;
  margin-right: 8px;
`

export const BenefitBlock = styled.div`
  margin-top: 4px;
  padding: 12px;
  border-radius: 8px;
  background: #f6ffed;
  border: 1px solid #b7eb8f;
`

export const BenefitValue = styled.div`
  display: flex;
  align-items: baseline;
  gap: 8px;
  font-size: 20px;
  font-weight: 600;
  color: #389e0d;
  line-height: 1.2;
  margin: 4px 0;
`

export const BenefitPercent = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: #52c41a;
`

export const ApplyFooter = styled.div`
  position: sticky;
  bottom: 0;
  z-index: 10;
  margin-top: 24px;
  padding: 12px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.04);
`
